/**
 * Ad landing conversion layer (v2 — contrast + buy modules + sticky)
 * - Sticky ATC bar
 * - Repeated mid-page buy modules (same offer, same CTAs)
 * Hero SKU: Medium pan
 * Pages: chefs-pan, buy-once-cook-for-decades, no-coating,
 *        chefs-pan-compare, titanore-vs-nonstick
 */
(function () {
  var HANDLES = [
    'chefs-pan',
    'buy-once-cook-for-decades',
    'no-coating',
    'chefs-pan-compare',
    'titanore-vs-nonstick',
    'chefs-50-off',
    'chef-deal-50',
    'chef-deal-50-us',
    'chef-deal-50-uk'
  ];
  var path = (window.location.pathname || '').replace(/\/$/, '');
  var match = HANDLES.some(function (h) {
    return path === '/pages/' + h || path.endsWith('/pages/' + h);
  });
  if (!match) return;
  /* Luxury LP ships its own sticky ATC + buy UI — do not double-inject. */
  if (document.querySelector('.tl-lux') || document.body.classList.contains('template-page-chefs-pan-luxury')) return;

  var VARIANT_ID = 57830474842499; // Medium
  var PRICE = '€100';
  var WAS_PRICE = '€166.67';
  var SHIP_LINE = ' · gratis verzending · gelaagd titanium · PFAS-vrij';
  var PDP =
    '/products/titanium-hammered-pan-pro-medium' +
    (window.location.search || '');
  var IS_SALE = path.indexOf('/pages/chefs-pan') !== -1 || path.indexOf('/pages/chefs-50-off') !== -1 || path.indexOf('/pages/chef-deal-50') !== -1 || path.indexOf('/pages/no-coating') !== -1 || path.indexOf('/pages/buy-once') !== -1 || path.indexOf('/pages/chefs-pan-compare') !== -1;
  var IS_EN_MARKET =
    path.indexOf('chef-deal-50-us') !== -1 || path.indexOf('chef-deal-50-uk') !== -1;
  // NL/EU pages: Dutch source copy for Weglot. US/UK keep English market copy.
  /* EN source everywhere — Weglot handles NL (avoids EN body + NL sticky mix) */
  var SALE_KICKER = 'ONLINE OFFER';
  var SALE_CTA = 'Buy for €100';
  var SALE_LINK = 'View product';
  var SALE_PCT = '40% SUMMER DISCOUNT';
  var SALE_STICKY_EXTRA = ' · free shipping · PFAS-free';
  SHIP_LINE = ' · free shipping · layered titanium · PFAS-free';
  if (IS_SALE) {
    PRICE = '€100';
    WAS_PRICE = '€166.67';
    PDP = '/products/titanium-hammered-pan-pro-medium';
    if (path.indexOf('chef-deal-50-us') !== -1) {
      PRICE = '€100';
      WAS_PRICE = '€166.67';
      PDP = '/products/titanium-hammered-pan-pro-medium?country=US';
    } else if (path.indexOf('chef-deal-50-uk') !== -1) {
      PRICE = '€100';
      WAS_PRICE = '€166.67';
      PDP = '/products/titanium-hammered-pan-pro-medium?country=GB';
    }
  }

  // Insert a buy module after these section headlines (chefs-pan)
  var AFTER_HEADLINES = [
    'twenty-three years behind the stove',
    'one metal. no coating',
    'your pan deserves the same attention',
    'this is where a chef gets picky',
    'buy once. cook for decades',
    'this is the one i kept',
    'vs. an ordinary non-stick',
    'the pan built to outlast non-stick'
  ];

  function injectStyles() {
    if (document.getElementById('tl-ad-sticky-css')) return;
    var style = document.createElement('style');
    style.id = 'tl-ad-sticky-css';
    style.textContent = [
      '#tl-ad-sticky{position:fixed;left:0;right:0;bottom:0;z-index:99999;background:#FDF8F2;color:#171714;border-top:1px solid rgba(23,23,20,.12);padding:12px 16px calc(12px + env(safe-area-inset-bottom));font-family:"Manrope","DM Sans",system-ui,sans-serif;box-shadow:0 -8px 28px rgba(23,23,20,.06)}',
      '#tl-ad-sticky .tl-ad-inner{max-width:720px;margin:0 auto;display:grid;grid-template-columns:1fr auto;gap:12px;align-items:center}',
      '#tl-ad-sticky .tl-ad-copy{min-width:0}',
      '#tl-ad-sticky .tl-ad-title{font-size:14px;font-weight:600;line-height:1.25;margin:0;color:#171714}',
      '#tl-ad-sticky .tl-ad-sub{font-size:12px;color:#5c5850;margin:4px 0 0;line-height:1.3;font-variant-numeric:tabular-nums;font-family:"Manrope","DM Sans",system-ui,-apple-system,sans-serif}',
      '#tl-ad-sticky .tl-ad-price{color:#BC7B5E;font-weight:700}',
      '#tl-ad-sticky .tl-ad-actions{display:flex;gap:8px;align-items:center;flex-shrink:0}',
      '#tl-ad-sticky .tl-ad-cta{appearance:none;border:0;background:#BC7B5E;color:#171714;font:inherit;font-size:14px;font-weight:700;padding:12px 16px;border-radius:6px;cursor:pointer;white-space:nowrap}',
      '#tl-ad-sticky .tl-ad-cta:disabled{opacity:.65;cursor:wait}',
      '#tl-ad-sticky .tl-ad-link{color:#BC7B5E;font-size:12px;font-weight:600;text-decoration:none;white-space:nowrap}',
      '#tl-ad-sticky .tl-ad-link:hover{text-decoration:underline}',
      'body.tl-ad-sticky-on{padding-bottom:88px}',
      '@media (max-width:480px){#tl-ad-sticky .tl-ad-inner{grid-template-columns:1fr}#tl-ad-sticky .tl-ad-actions{width:100%}#tl-ad-sticky .tl-ad-cta{flex:1;text-align:center}#tl-ad-sticky .tl-ad-link{display:none}}',

      /* Mid-page buy modules */
      '.tl-ad-buy{width:100%;box-sizing:border-box;margin:28px 0;padding:22px 20px;border-top:1px solid rgba(200,149,108,.35);border-bottom:1px solid rgba(200,149,108,.35);background:#FDF8F2;font-family:"Manrope","DM Sans",system-ui,sans-serif;color:#171714}',
      '.sec.dark .tl-ad-buy,.sec.hero .tl-ad-buy,.sec-dark .tl-ad-buy{background:rgba(252,250,245,.92);border-top-color:rgba(200,149,108,.45);border-bottom-color:rgba(200,149,108,.45);color:#171714}',
      '.tl-ad-buy-inner{max-width:640px;margin:0 auto;display:grid;grid-template-columns:1fr auto;gap:16px 20px;align-items:center}',
      '.tl-ad-buy-kicker{margin:0 0 6px;font-size:11px;letter-spacing:.14em;text-transform:uppercase;color:#BC7B5E;font-weight:700}',
      '.tl-ad-buy-title{margin:0;font-size:18px;line-height:1.25;font-weight:600;color:#171714!important}',
      '.sec.dark .tl-ad-buy-title,.sec.hero .tl-ad-buy-title,.sec-dark .tl-ad-buy-title{color:#171714!important}',
      '.tl-ad-buy-sub{margin:6px 0 0;font-size:14px;color:#5c5850;line-height:1.4}',
      '.sec.dark .tl-ad-buy-sub,.sec.hero .tl-ad-buy-sub,.sec-dark .tl-ad-buy-sub{color:#5c5850}',
      '.tl-ad-buy-sub strong{color:#BC7B5E;font-weight:700}',
      '.tl-ad-buy-actions{display:flex;flex-direction:column;align-items:stretch;gap:8px;min-width:160px}',
      '.tl-ad-buy-cta{appearance:none;border:0;background:#BC7B5E;color:#171714;font:inherit;font-size:15px;font-weight:700;padding:14px 18px;border-radius:6px;cursor:pointer;text-align:center;text-decoration:none}',
      '.tl-ad-buy-cta:disabled{opacity:.65;cursor:wait}',
      '.tl-ad-buy-link{font-size:13px;font-weight:600;color:#171714;opacity:.7;text-align:center;text-decoration:underline;text-underline-offset:2px}',
      '.tl-ad-buy-link:hover{opacity:1}',
      '@media (max-width:640px){.tl-ad-buy-inner{grid-template-columns:1fr}.tl-ad-buy-actions{min-width:0}}',

      /* Contrast fix: beat global cream !important on light LP surfaces */
      '.tgp .light,.tl-chefs-lp .sec-porcelain{color:#171714 !important}',
      '.tgp .light h1,.tgp .light h2,.tgp .light h3,.tgp .light h4,.tgp .light .benefits h3,.tl-chefs-lp h1,.tl-chefs-lp h2,.tl-chefs-lp h3{color:#171714 !important}',
      '.tgp .light p,.tgp .light li,.tgp .light td,.tgp .light th{color:#2c2925 !important}',
      '.tgp .light .benefits p,.tgp .light .caption,.tgp .light .trust{color:#6b6560 !important}',
      '.tgp .light .eyebrow{color:#b98a49 !important}',
      '.tgp .light .quote{color:#171714 !important}',
      '.tgp .light a:not(.btn):not(.tl-ad-buy-cta):not(.tl-ad-buy-link){color:#171714 !important}',
      /* Keep dark sections intentionally light-on-dark */
      '.tgp .dark,.tgp .hero,.tl-chefs-lp .sec-dark,.tl-chefs-lp .hero{color:#f4f0ea !important}',
      '.tgp .dark h1,.tgp .dark h2,.tgp .dark h3,.tgp .hero h1,.tgp .hero h2,.tl-chefs-lp .hero h1,.tl-chefs-lp .sec-dark h1,.tl-chefs-lp .sec-dark h2{color:#f4f0ea !important}',
      '.tgp .dark .eyebrow,.tgp .hero .eyebrow{color:#b98a49 !important}'
    ].join('');
    document.head.appendChild(style);
  }

  function addToCart(btn) {
    if (!btn || btn.disabled) return;
    if (IS_SALE) {
      window.location.href = PDP;
      return;
    }
    btn.disabled = true;
    var prev = btn.textContent;
    btn.textContent = 'Bezig…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: VARIANT_ID, quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add_failed');
        var drawer =
          document.querySelector('cart-drawer') ||
          document.querySelector('#CartDrawer') ||
          document.querySelector('[id*="cart-drawer" i]');
        if (drawer && typeof drawer.open === 'function') {
          drawer.open();
          btn.disabled = false;
          btn.textContent = prev;
          return;
        }
        window.location.href = '/cart';
      })
      .catch(function () {
        window.location.href = PDP;
      });
  }

  function buyModuleHtml(id) {
    return (
      '<div class="tl-ad-buy" id="' + id + '" data-tl-ad-buy>' +
        '<div class="tl-ad-buy-inner">' +
          '<div>' +
            '<p class="tl-ad-buy-kicker">' + (IS_SALE ? SALE_KICKER : 'Koop hier') + '</p>' +
            '<p class="tl-ad-buy-title">Titanium Hammered Pan Pro · Medium</p>' +
            '<p class="tl-ad-buy-sub"><strong>' + PRICE + '</strong>' + (WAS_PRICE ? ' <span style="text-decoration:line-through;opacity:.6">' + WAS_PRICE + '</span>' : '') + SHIP_LINE + '</p>' +
          '</div>' +
          '<div class="tl-ad-buy-actions">' +
            '<button type="button" class="tl-ad-buy-cta" data-tl-ad-atc>' + (IS_SALE ? SALE_CTA : 'In winkelwagen') + '</button>' +
            '<a class="tl-ad-buy-link" href="' + PDP + '">' + (IS_SALE ? SALE_LINK : 'Bekijk productpagina') + '</a>' +
          '</div>' +
        '</div>' +
      '</div>'
    );
  }

  function bindAtc(root) {
    root.querySelectorAll('[data-tl-ad-atc]').forEach(function (btn) {
      if (btn.getAttribute('data-tl-bound')) return;
      btn.setAttribute('data-tl-bound', '1');
      btn.addEventListener('click', function () {
        addToCart(btn);
      });
    });
  }

  function insertAfter(node, html) {
    if (!node || !node.parentNode) return null;
    var wrap = document.createElement('div');
    wrap.innerHTML = html;
    var el = wrap.firstElementChild;
    if (!el) return null;
    if (node.nextSibling) node.parentNode.insertBefore(el, node.nextSibling);
    else node.parentNode.appendChild(el);
    bindAtc(el);
    return el;
  }

  function normalize(text) {
    return (text || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function headlineMatches(text) {
    var n = normalize(text);
    return AFTER_HEADLINES.some(function (h) {
      return n.indexOf(h) !== -1;
    });
  }

  function ensureSticky() {
    if (document.getElementById('tl-ad-sticky')) return;
    var bar = document.createElement('div');
    bar.id = 'tl-ad-sticky';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', IS_EN_MARKET ? 'Buy Titanium Pan Medium' : 'Koop Titanium Pan Medium');
    bar.innerHTML =
      '<div class="tl-ad-inner">' +
        '<div class="tl-ad-copy">' +
          '<p class="tl-ad-title">Titanium Hammered Pan Pro · Medium</p>' +
          '<p class="tl-ad-sub"><span class="tl-ad-price">' + PRICE + '</span>' + (WAS_PRICE ? ' <span style="text-decoration:line-through;opacity:.55">' + WAS_PRICE + '</span> · ' + SALE_PCT : SALE_STICKY_EXTRA) + '</p>' +
        '</div>' +
        '<div class="tl-ad-actions">' +
          '<a class="tl-ad-link" href="' + PDP + '" translate="no">' + (IS_EN_MARKET ? 'View product' : 'Bekijk product') + '</a>' +
          '<button type="button" class="tl-ad-cta" data-tl-ad-atc>' + (IS_SALE ? SALE_CTA : (IS_EN_MARKET ? 'Add to cart' : 'In winkelwagen')) + '</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(bar);
    document.body.classList.add('tl-ad-sticky-on');
    bindAtc(bar);
  }

  function insertInlineModules() {
    if (document.querySelector('[data-tl-ad-buy]')) return;

    var inserted = 0;
    var max = 6;

    // 1) Right after hero section on chefs-pan
    var hero = document.querySelector('section.sec.hero');
    if (hero) {
      insertAfter(hero, buyModuleHtml('tl-ad-buy-hero'));
      inserted++;
    }

    // 2) After key story sections (by H2)
    var heads = document.querySelectorAll('h1, h2');
    heads.forEach(function (h) {
      if (inserted >= max) return;
      if (!headlineMatches(h.textContent)) return;
      var section = h.closest('section.sec') || h.closest('section') || h.parentElement;
      if (!section) return;
      if (section.querySelector('[data-tl-ad-buy]')) return;
      // Avoid double-insert directly under FAQ title — put module before FAQ instead
      var t = normalize(h.textContent);
      if (t.indexOf('frequently asked') !== -1 || t.indexOf('veelgestelde') !== -1) {
        var mod = document.createElement('div');
        mod.innerHTML = buyModuleHtml('tl-ad-buy-pre-faq');
        var el = mod.firstElementChild;
        section.parentNode.insertBefore(el, section);
        bindAtc(el);
        inserted++;
        return;
      }
      insertAfter(section, buyModuleHtml('tl-ad-buy-' + inserted));
      inserted++;
    });

    // 3) Fallback for pages without .sec (buy-once / no-coating): every 2nd H2
    if (inserted < 3) {
      var h2s = Array.prototype.slice.call(document.querySelectorAll('h2')).filter(function (h) {
        var t = normalize(h.textContent);
        return t && t.indexOf('cart') === -1 && t.indexOf('shipping insurance') === -1;
      });
      h2s.forEach(function (h, i) {
        if (inserted >= max) return;
        if (i % 2 !== 1) return;
        var block = h.closest('section') || h.parentElement;
        if (!block || block.querySelector('[data-tl-ad-buy]')) return;
        insertAfter(block, buyModuleHtml('tl-ad-buy-fb-' + inserted));
        inserted++;
      });
    }

    // 4) Always one near the end of main content
    if (inserted < max) {
      var main =
        document.querySelector('main') ||
        document.querySelector('#MainContent') ||
        document.querySelector('.shopify-section:last-of-type');
      if (main && !main.querySelector('#tl-ad-buy-end')) {
        var end = document.createElement('div');
        end.innerHTML = buyModuleHtml('tl-ad-buy-end');
        var endEl = end.firstElementChild;
        main.appendChild(endEl);
        bindAtc(endEl);
      }
    }
  }

  function init() {
    injectStyles();
    ensureSticky();
    insertInlineModules();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* cache-bust 2026-08-07 */
